import { Routes } from '@angular/router';
import { activeRedeemWindowGuard } from './guards/active-redeem-window.guard';
import { successGuard } from './guards/success.guard';
import { redirectToShowcodeGuard } from './guards/redirect-to-showcode.guard';
import { adminAuthGuard } from './core/auth/admin-auth.guard';
import { merchantCodeResolver } from './public/merchant-code.resolver';

export const routes: Routes = [
  // ---- admin (desktop) — static paths must stay above the public `:code` route
  {
    path: 'admin/login',
    loadComponent: () => import('./admin/admin-login').then((m) => m.AdminLogin),
    title: 'Admin login',
  },
  {
    path: 'admin',
    canActivate: [adminAuthGuard],
    loadComponent: () => import('./admin/admin-shell').then((m) => m.AdminShell),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', loadComponent: () => import('./admin/dashboard').then((m) => m.AdminDashboard), title: 'Dashboard' },
      { path: 'merchants', loadComponent: () => import('./admin/merchants').then((m) => m.AdminMerchants), title: 'Merchants' },
      { path: 'promotions', loadComponent: () => import('./admin/promotions').then((m) => m.AdminPromotions), title: 'Promotions' },
      { path: 'promotions/new', loadComponent: () => import('./admin/promotion-edit').then((m) => m.PromotionEdit), title: 'New promotion' },
      { path: 'promotions/:id', loadComponent: () => import('./admin/promotion-edit').then((m) => m.PromotionEdit), title: 'Edit promotion' },
      { path: 'promotion-order', loadComponent: () => import('./admin/promotion-order').then((m) => m.AdminPromotionOrder), title: 'Promotion order' },
      { path: 'quota-groups', loadComponent: () => import('./admin/quota-groups').then((m) => m.AdminQuotaGroups), title: 'Quota groups' },
      { path: 'quota-groups/:id', loadComponent: () => import('./admin/quota-group-detail').then((m) => m.QuotaGroupDetail), title: 'Quota group' },
      { path: 'reports', loadComponent: () => import('./admin/reports').then((m) => m.AdminReports), title: 'Reports' },
    ],
  },

  // ---- public (mobile only)
  {
    path: '',
    loadComponent: () => import('./public/public-shell').then((m) => m.PublicShell),
    children: [
      { path: '', pathMatch: 'full', canActivate: [redirectToShowcodeGuard], loadComponent: () => import('./public/banner').then((m) => m.Banner), title: 'CardX' },
      { path: 'merchants', canActivate: [redirectToShowcodeGuard], loadComponent: () => import('./public/merchant-list').then((m) => m.MerchantList), title: 'เลือกร้านค้า' },
      { path: 'merchants/:merchantId', loadComponent: () => import('./public/promotion-list').then((m) => m.PromotionList), title: 'โปรโมชั่น' },
      { path: 'promotions/:promotionId', loadComponent: () => import('./public/promotion-detail').then((m) => m.PromotionDetail), title: 'รายละเอียดโปรโมชั่น' },
      { path: 'code', canActivate: [activeRedeemWindowGuard], loadComponent: () => import('./public/show-code').then((m) => m.ShowCode), title: 'รหัสโปรโมชั่น' },
      { path: 'success', canActivate: [successGuard], loadComponent: () => import('./public/success').then((m) => m.Success), title: 'ได้รับสิทธิ์แล้ว' },
      { path: 'not-found', loadComponent: () => import('./public/not-found').then((m) => m.NotFound), title: 'ไม่พบหน้า' },
      // Merchant QR entry: /APEX → banner → /APEX/promotions (no Back button)
      {
        path: ':code',
        canActivate: [redirectToShowcodeGuard],
        resolve: { merchant: merchantCodeResolver },
        children: [
          { path: '', pathMatch: 'full', loadComponent: () => import('./public/banner').then((m) => m.Banner), title: 'CardX' },
          { path: 'promotions', loadComponent: () => import('./public/promotion-list').then((m) => m.PromotionList), title: 'โปรโมชั่น' },
        ],
      },
      { path: '**', redirectTo: 'not-found' },
    ],
  },
];
